import React from 'react'

const Manual_digifact_descarga_reporte = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Pasos para descargar el reporte en la plataforma de Digifact
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Este proceso permite generar y descargar un reporte mensual desde la plataforma de Digifact. Al acceder al módulo de reportes, se deben aplicar los filtros de fecha correspondientes al mes deseado y luego generar el informe para finalmente descargarlo en formato digital.
        </p>
        <iframe
          src="https://scribehow.com/embed/Pasos_para_descargar_el_reporte_en_la_plataforma_de_Digifact__WDf4P1gVR0WjR1A1wN1D4w?as=scrollable"
          className="scribe-iframe-general-57"
          width="100%"
          height="800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_digifact_descarga_reporte